import script from "./KYCSuccessCards.vue?vue&type=script&setup=true&lang=js"
export * from "./KYCSuccessCards.vue?vue&type=script&setup=true&lang=js"

import "./KYCSuccessCards.vue?vue&type=style&index=0&id=558ebd6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aparl\\Source\\Incodi\\gdm-self-service\\selfservice.dynamicmarkets.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558ebd6c"]])

export default __exports__